import React from "react";
import { Day, DayProps, IMessage } from "react-native-gifted-chat";
import { getFormatedDate } from "react-native-modern-datepicker";

export default function ChatDay(props: DayProps<IMessage>) {
  return (
    <Day
      {...props}
      dateValue={getFormatedDate(
        props.currentMessage?.createdAt as Date,
        "jYYYY/jM/jD"
      )}
    />
  );
}
